<template>
  <div class="tab-config-container">
    <el-card>
      <div class="card-header">
        <el-button type="primary" @click="openAddDialog">添加Tab</el-button>
      </div>
      <el-table :data="tabList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="text" label="Tab文本"></el-table-column>
        <el-table-column prop="value" label="Tab值"></el-table-column>
        <el-table-column prop="image" label="Tab图片" width="120">
          <template slot-scope="scope">
            <el-image v-if="scope.row.image" :src="scope.row.image" fit="cover" style="width: 60px; height: 40px;"></el-image>
            <span v-else>无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="small" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加/编辑Tab对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="tabForm" :rules="tabRules" ref="tabForm" label-width="80px">
        <el-form-item label="Tab文本" prop="text">
          <el-input v-model="tabForm.text" placeholder="请输入Tab文本"></el-input>
        </el-form-item>
        <el-form-item label="Tab值" prop="value">
          <el-input v-model="tabForm.value" placeholder="请输入Tab值"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="tabForm.sort" :min="1" :max="999" placeholder="请输入排序值"></el-input-number>
        </el-form-item>
        <el-form-item label="Tab图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="handleImageSuccess"
            :before-upload="beforeAvatarUpload"
            ref="upload"
          >
            <img v-if="tabForm.image" :src="tabForm.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTabForm('tabForm')">确定</el-button>
      </div>
    </el-dialog>

    <!-- 预览区域 -->
    <el-card class="mt-20">
      <h3>Tab预览</h3>
      <el-tabs v-model="activeTab" class="mt-10">
        <el-tab-pane v-for="tab in tabList" :key="tab.id" :label="tab.text" :name="tab.value">
          <div class="tab-content">
            这是{{ tab.text }}的内容区域
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'TabConfig',
  data() {
    return {
      tabList: [],
      dialogVisible: false,
      dialogTitle: '添加Tab',
      activeTab: '',
      uploadUrl: '/api/chuanmei/tab-config/upload',
      tabForm: {
        id: '',
        text: '',
        value: '',
        image: '',
        sort: 1
      },
      tabRules: {
        text: [
          { required: true, message: '请输入Tab文本', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入Tab值', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadTabList()
  },
  methods: {
    loadTabList() {
      this.$http.get('/chuanmei/tab-config')
        .then(response => {
          if (response.data.success) {
            this.tabList = response.data.data.map(item => {
              return {
                id: item.id.toString(),
                text: item.text,
                value: item.value,
                image: item.image,
                sort: item.sort,
                create_time: item.create_time,
                createTime: new Date(item.create_time).toLocaleString()
              }
            })
            if (this.tabList.length > 0) {
              this.activeTab = this.tabList[0].value
            }
          } else {
            this.$message.error('获取Tab列表失败')
          }
        })
        .catch(error => {
          console.error('获取Tab列表失败:', error)
          this.$message.error('获取Tab列表失败，请稍后重试')
        })
    },
    handleImageSuccess(response, file) {
      if (response.success) {
        this.tabForm.image = response.data.image
        this.$message.success('图片上传成功')
      } else {
        this.$message.error('图片上传失败')
      }
    },
    beforeAvatarUpload(file) {
      const isPNG = file.type === 'image/png'
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isGIF = file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isPNG && !isJPG && !isJPEG && !isGIF) {
        this.$message.error('上传图片只能是 PNG、JPG、JPEG 或 GIF 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    openAddDialog() {
      this.dialogTitle = '添加Tab'
      this.tabForm = {
        id: '',
        text: '',
        value: '',
        image: '',
        sort: 1
      }
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.dialogTitle = '编辑Tab'
      this.tabForm = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },
    submitTabForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const formData = new FormData()
          formData.append('text', this.tabForm.text)
          formData.append('value', this.tabForm.value)
          formData.append('sort', this.tabForm.sort)
          
          if (this.tabForm.image && typeof this.tabForm.image === 'string') {
            formData.append('image', this.tabForm.image)
          }

          if (this.tabForm.id) {
            // 编辑Tab
            this.$http.put(`/chuanmei/tab-config/${this.tabForm.id}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
              .then(response => {
                if (response.data.success) {
                  this.$message.success('编辑成功')
                  this.dialogVisible = false
                  this.loadTabList()
                } else {
                  this.$message.error(response.data.message || '编辑失败')
                }
              })
              .catch(error => {
                console.error('编辑Tab失败:', error)
                this.$message.error('编辑Tab失败，请稍后重试')
              })
          } else {
            // 添加Tab
            this.$http.post('/chuanmei/tab-config', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
              .then(response => {
                if (response.data.success) {
                  this.$message.success('添加成功')
                  this.dialogVisible = false
                  this.loadTabList()
                } else {
                  this.$message.error(response.data.message || '添加失败')
                }
              })
              .catch(error => {
                console.error('添加Tab失败:', error)
                this.$message.error('添加Tab失败，请稍后重试')
              })
          }
        } else {
          return false
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除这个Tab吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/chuanmei/tab-config/${id}`)
          .then(response => {
            if (response.data.success) {
              this.$message.success('删除成功')
              this.loadTabList()
            } else {
              this.$message.error(response.data.message || '删除失败')
            }
          })
          .catch(error => {
            console.error('删除Tab失败:', error)
            this.$message.error('删除Tab失败，请稍后重试')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.tab-config-container {
  max-width: 1200px;
  margin: 0 auto;
}

.card-header {
  margin-bottom: 20px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-20 {
  margin-top: 20px;
}

.tab-content {
  padding: 20px;
  min-height: 200px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/TabConfig.vue